import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { usersService } from "../../services/UsersService";
import { formatDateTime } from "../../config/Config";

export const UserGroupHistory = ({ userID }) => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);

	useEffect(() => {
		setLoading(true);
		usersService
			.getGroupsAudit(userID)
			.then((data) => {
				setData(data);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				console.error("Error fetching groups audit:", error);
			});
	}, [userID]);

	return (
		<>
			<DataTable size="small" value={data} paginator rows={10} rowsPerPageOptions={[5, 10, 25]} loading={loading}>
				<Column field="groupName" header="Group Name" />
				<Column field="auditDate" header="Effective Date" body={(e) => formatDateTime(e.auditDate)} />
				<Column field="createdBy" header="Assigned By" />
				<Column field="updatedBy" header="Assigned Date" />
				<Column field="createdBy" header="Assigned By" />
				<Column field="updatedBy" header="Assigned Date" />
			</DataTable>
		</>
	);
};
